import React from 'react';

import { IconProps, StyledPath, StyledStrokedGroup, StyledSvg } from '../iconCommons';

export const IconDoubleChevron = ({ color = 'currentColor', size = 'xSmall', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 14" fill="none" size={size} {...props}>
        <StyledStrokedGroup color={color}>
            <StyledPath
                d="M6.46265 12.5714L1.19979 7.29998C1.15879 7.2615 1.12612 7.21503 1.10378 7.16343C1.08144 7.11184 1.06992 7.05621 1.06992 6.99998C1.06992 6.94376 1.08144 6.88813 1.10378 6.83653C1.12612 6.78493 1.15879 6.73846 1.19979 6.69998L6.46265 1.42855"
                strokeLinecap="round"
                strokeLinejoin="round"
                color="none"
            />
            <StyledPath
                d="M10.9285 12.5714L5.65704 7.29998C5.57851 7.21987 5.53453 7.11216 5.53453 6.99998C5.53453 6.8878 5.57851 6.78009 5.65704 6.69998L10.9285 1.42855"
                strokeLinecap="round"
                strokeLinejoin="round"
                color="none"
            />
        </StyledStrokedGroup>
    </StyledSvg>
);
